export const validateRedirectUrl = (
  redirectUrl: string | undefined | null,
  fallback: string = '/'
): string => {
  if (!redirectUrl) {
    return fallback
  }

  let decodedUrl: string
  try {
    decodedUrl = decodeURIComponent(redirectUrl)
  } catch {
    return fallback
  }

  if (decodedUrl.startsWith('/')) {
    if (
      decodedUrl.startsWith('//') ||
      decodedUrl.includes('://') ||
      decodedUrl.includes('javascript:') ||
      decodedUrl.includes('data:')
    ) {
      return fallback
    }

    return redirectUrl
  }

  return fallback
}
